import { render, staticRenderFns } from "./VoiceAgentChannels.vue?vue&type=template&id=2a83900d&scoped=true"
import script from "./VoiceAgentChannels.vue?vue&type=script&lang=js"
export * from "./VoiceAgentChannels.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgentChannels.vue?vue&type=style&index=0&id=2a83900d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83900d",
  null
  
)

export default component.exports